import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=c73698aa&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"
import style0 from "./PanelCard.vue?vue&type=style&index=0&id=c73698aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73698aa",
  null
  
)

export default component.exports